<script>
import { permissionsMixin } from '@/mixins/userPermissions';

export default {
  mixins: [permissionsMixin],

  mounted() {
    this.setPermissions(this.auth);
  },

  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
  },
};
</script>

<template>
  <div class="col-xl-3 theiaStickySidebar">
    <div class="card">
      <div class="card-body">
        <div class="d-flex flex-column list-group settings-list">

          <router-link to="/others-settings/configurations" class="d-inline-flex align-items-center rounded py-2 px-3"
            active-class="active" exact-active-class="active">
            <i v-if="isActive('/others-settings/configurations')" class="ti ti-arrow-badge-right me-2"></i>
            Configuration</router-link>

          <router-link to="/others-settings/roles" class="d-inline-flex align-items-center rounded py-2 px-3"
            active-class="active" exact-active-class="active">
            <i v-if="isActive('/others-settings/roles')" class="ti ti-arrow-badge-right me-2"></i>
            Roles & Permissions</router-link>

          <router-link to="/others-settings/whatsapp-followup-templates"
            class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active"
            v-if="getPermission('Zoho_Payment', 'read')">
            <i v-if="isActive('/others-settings/whatsapp-followup-templates')" class="ti ti-arrow-badge-right me-2"></i>
            WhatsApp Followup Templates</router-link>

          <router-link to="/others-settings/brands" class="d-inline-flex align-items-center rounded py-2 px-3"
            active-class="active" exact-active-class="active" v-if="getPermission('Brand', 'read')">
            <i v-if="isActive('/others-settings/brands')" class="ti ti-arrow-badge-right me-2"></i>
            Brands
          </router-link>

          <router-link to="/others-settings/engineer"
            class="d-inline-flex align-items-center rounded py-2 px-3"
            active-class="active"
            exact-active-class="active" v-if="getPermission('Engineer', 'read')">

            <i v-if="isActive('/others-settings/engineer')" class="ti ti-arrow-badge-right me-2"></i>
            Engineer
          </router-link>

          <router-link to="/others-settings/sales-executives"
              class="d-inline-flex align-items-center rounded py-2 px-3"
              active-class="active"
              exact-active-class="active" v-if="getPermission('Sales_Executive', 'read')">

              <i v-if="isActive('/others-settings/sales-executives')" class="ti ti-arrow-badge-right me-2"></i>
              Sales Executive
          </router-link>

          <router-link to="/others-settings/site-inspectors"
              class="d-inline-flex align-items-center rounded py-2 px-3"
              active-class="active"
              exact-active-class="active" v-if="getPermission('Site_Inspection', 'read')">

              <i v-if="isActive('/others-settings/site-inspectors')" class="ti ti-arrow-badge-right me-2"></i>
              Site Inspector
          </router-link>

          <router-link to="/others-settings/internal-consumptions"
            class="d-inline-flex align-items-center rounded py-2 px-3"
            active-class="active"
            exact-active-class="active" v-if="getPermission('Internal_Consumption', 'read')">

            <i v-if="isActive('/others-settings/internal-consumptions')" class="ti ti-arrow-badge-right me-2"></i>
            Internal Consumption
        </router-link>

        </div>
      </div>
    </div>
  </div>
</template>
